export class StockRequest {
    public company_code;
    public supplier_code;
    public language;
    public type;
}



// WEBPACK FOOTER //
// ./src/app/model/stock/stock_request.model.ts